import { call, put, takeLatest } from 'redux-saga/effects';
import * as actions from './mfa.actions';
import { login } from '../auth/auth.action';
import * as calls from './mfa.calls';

import {
  MfaDisableAction,
  MfaEnableAction,
  MfaSmsSetupAction,
  MfaSmsVerifyAction,
  MfaSmsDisableAction,
  MfaTotpDisableAction,
  MfaTotpVerifyAction
} from './mfa.types';
import { extractErrorAndShowToast } from '../../utils/helpers/extractErrorAndShowToast';

function* mfaEnable({ payload }: MfaEnableAction) {
  try {
    yield call(calls.enableMfa);
    yield call(() => payload?.successCb && payload.successCb());
  } catch (e) {
    const { data } = e.response;
    yield put(actions.mfaEnableFailure(data));
  }
}

function* mfaDisable({ payload }: MfaDisableAction) {
  try {
    yield call(calls.disableMfa);
    yield call(mfaGetInfo);
    yield call(payload.successCb);
  } catch (e) {
    const { data } = e.response;
    yield call(payload.errorCb);
    yield put(actions.mfaDisableFailure(data));
  }
}

function* mfaGetInfo() {
  try {
    const { data } = yield call(calls.mfaInfo);
    yield put(actions.mfaGetInfoSuccess(data));
  } catch (e) {
    const { data } = e.response;
    yield put(actions.mfaGetInfoFailure(data));
  }
}

function* mfaSmsSetup({ payload }: MfaSmsSetupAction) {
  try {
    yield call(calls.mfaSmsSetup, payload.phoneNumber);
  } catch (e) {
    yield payload.errorCb(e.response?.errorInfo || { message: e.message });
  }
}

function* mfaSmsVerify({ payload }: MfaSmsVerifyAction) {
  try {
    yield put(actions.mfaSetError());
    yield call(calls.mfaSmsVerify, payload.verificationCode);
    yield put(actions.mfaSmsVerifySuccess(payload.phoneNumber));
    yield put(login({ referer: '', callCsrfFlag: true }));
    yield call(payload.cb);
  } catch (e) {
    yield payload.errorCb(e.response?.errorInfo || { message: e.message });
  }
}

function* mfaSmsDisable({ payload }: MfaSmsDisableAction) {
  try {
    yield call(calls.mfaSmsDisable);
    yield put(actions.mfaSmsDisableSuccess());
    yield call(() => payload.cb());
  } catch (e) {
    extractErrorAndShowToast(e);
  }
}

function* mfaTotpVerify({ payload }: MfaTotpVerifyAction) {
  try {
    yield put(actions.mfaSetError());
    yield call(calls.mfaTotpVerify, payload.verificationCode);
    yield put(actions.mfaTotpVerifySuccess());
    yield put(login({ referer: '', callCsrfFlag: true }));
    yield call(payload.cb);
  } catch (e) {
    yield payload.errorCb(e.response?.errorInfo || { message: e.message });
  }
}

function* mfaTotpDisable({ payload }: MfaTotpDisableAction) {
  try {
    yield call(calls.mfaTotpDisable);
    yield put(actions.mfaTotpDisableSuccess());
    yield call(() => payload.cb());
  } catch (e) {
    extractErrorAndShowToast(e);
  }
}

function* mfaSaga() {
  yield takeLatest('MFA_INFO_REQUEST', mfaGetInfo);
  yield takeLatest('MFA_ENABLE_REQUEST', mfaEnable);
  yield takeLatest('MFA_DISABLE_REQUEST', mfaDisable);
  yield takeLatest('MFA_SMS_SETUP_REQUEST', mfaSmsSetup);
  yield takeLatest('MFA_SMS_VERIFY_REQUEST', mfaSmsVerify);
  yield takeLatest('MFA_SMS_DISABLE_REQUEST', mfaSmsDisable);
  yield takeLatest('MFA_TOTP_VERIFY_REQUEST', mfaTotpVerify);
  yield takeLatest('MFA_TOTP_DISABLE_REQUEST', mfaTotpDisable);
}

export default mfaSaga;
